module.exports = __webpack_public_path__ + "statics/img/Marketing-1.1f620f26.png";